import { typography } from "../../../base/styled/typography.style";
import { colors, defaultColors } from "../../../base/styled/variables.styled";
import styled from 'styled-components';
const palette = ({ colorVariant }) => colorVariant === "custom" ? defaultColors : colors;
export const SearchContainer = styled.div `
  max-width: 332px;
  background-color: ${(props) => palette(props).neutral000};
  border-radius: 8px;
  position: relative;

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }

  ${({ isFocused }) => isFocused && `
    z-index: 1000;
  `}

  &.disabled {
    opacity: 0.6;
    user-select: none;
    pointer-events: none;
    background-color: ${(props) => palette(props).neutral100};

    input {
      border-color: ${(props) => palette(props).neutral300};
      color: ${(props) => palette(props).neutral400};
      cursor: not-allowed;
    }

    button {
      color: ${(props) => palette(props).neutral400};
      cursor: not-allowed;
    }

    svg {
      opacity: 0.5;
    }
  }
`;
export const SearchForm = styled.form `
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
`;
export const SearchIcon = styled.div `
  color: ${(props) => props.inverse ? colors.neutral200 : palette(props).brand500};
	width: inherit;
	height: inherit;
	display: flex;
	justify-content: center;
	align-items: center;

	svg {
		width: 16px;
		height: 16px;
	}
`;
export const ClearButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  color: ${(props) => palette(props).brand500};
  cursor: pointer;

	svg {
		width: 16px;
		height: 16px;
	}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;
export const SuggestionsContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['colorVariant'].includes(prop),
}) `
  display: block;
  box-shadow: 0px 1px 4px 0px #005eb833;
  background-color: ${(props) => palette(props).neutral000};
  border-radius: 8px;
  position: absolute;
  padding: 4px;
  left: 0;
  width: calc(100% - 10px);
  top: 105%;
  z-index: 100;

  .ps-search-bar-autocomplete-scroll {
    max-height: 232px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: #f1f1f1;
      border: solid 5px transparent;
      border-radius: 100px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: solid 5px transparent;
      border-radius: 100px;
    }
  }
`;
export const SuggestionItem = styled.a.withConfig({
    shouldForwardProp: (prop) => !['colorVariant'].includes(prop),
}) `
	${typography.body2}
  text-decoration: none;
  padding: 8px 16px;
  display: block;
  width: calc(100% - 32px);
  border-radius: 4px;
  text-align: left;
  cursor: pointer;

  mark {
    color: ${(props) => palette(props).neutral500};
    background-color: transparent;
  }

  &:focus-visible {
    border: 0;
    -webkit-box-shadow: 0 0 0 3px ${(props) => palette(props).brand300};
    -moz-box-shadow: 0 0 0 3px ${(props) => palette(props).brand300};
    box-shadow: 0 0 0 3px ${(props) => palette(props).brand300};
  }

  &:hover {
    background-color: ${(props) => palette(props).brand75};
  }
`;
//# sourceMappingURL=Search.style.js.map